import React, { useEffect, useState, useRef, lazy } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle, ImageIcon } from 'lucide-react';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('New York');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    // Set initial states
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px' // Consider element as "passed" when it's 90% above the viewport
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px' // Consider top section visible when at least 30% is visible
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // When the section is no longer intersecting (scrolled past it)
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // When the top section is visible
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    // Small delay to ensure DOM is fully rendered
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  // Log the state for debugging
  useEffect(() => {
    console.log('Scrolled past first two sections:', isScrolledPastFirstTwoSections, 'At top section:', isAtTopSection);
  }, [isScrolledPastFirstTwoSections, isAtTopSection]);
  return <div className="w-full bg-white" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex justify-between items-center" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider" data-id="element-13">WOMEN'S HEALTH</span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
                <path fill="#f0f0f0" d="M103.622 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM167.737 160.624l-4.123 12.684h-13.336l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835h-13.336zM167.737 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM31.908 160.624l-4.123 12.684H14.449l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835H36.031zM31.908 219.081l-3.284 10.134H17.986l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333H35.192z" data-id="element-21" />
              </svg>
            </div>
            <span className="text-sm" data-id="element-22">Trending in the US</span>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-23">
        <div className="container mx-auto px-4 py-3" data-id="element-24">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-25">
            WOMEN'S HEALTH | Advertorial
          </p>
        </div>
      </header>

      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-26">
        <div className="container mx-auto px-4 py-3 flex items-center justify-center text-center" data-id="element-27">
          <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={20} data-id="element-28" />
          <p className="font-bold text-sm sm:text-base" data-id="element-29">
            UPDATE: Elivara Compression Leggings Are Selling Out FAST! Grab
            Yours NOW to get up to 40% OFF + Fast FREE Shipping Across the US
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="flex flex-col lg:flex-row lg:justify-center" data-id="element-31">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-32">
            <div className="py-6 px-0 md:px-4" data-id="element-33">
              {/* Headline */}
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4" data-id="element-34">
                {userCity} Lipedema Specialists Reveal: Why Compression
                Stockings Rarely Work for Lipedema (And What 17,000+ Diagnosed
                Women Are Using Instead)
              </h1>

              {/* Subheadline */}
              <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-35">
                If you've tried medical-grade compression and felt frustrated it
                wasn't helping, here's the lipedema-specific breakthrough that's
                finally providing relief.
              </p>

              {/* Author and Date */}
              <div className="flex items-center justify-between border-b border-gray-200 pb-4 mb-6" data-id="element-36">
                <div className="flex items-center" data-id="element-37">
                  <p className="text-sm text-gray-700" data-id="element-38">
                    By Jennifer Martinez, Women's Health | April 29, 2025
                  </p>
                </div>
                <div className="flex items-center text-sm text-gray-500" data-id="element-39">
                  <EyeIcon size={16} className="mr-1" data-id="element-40" />
                  <span data-id="element-41">312,847</span>
                </div>
              </div>

              {/* Featured Image */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-42">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hb7663489Vj6W5fHFmd7JR/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_21_%CF%80.%CE%BC..png" alt="Image of a woman looking frustrated while measuring her legs, showing visible disproportionate size compared to her upper body" className="w-full h-auto" data-id="element-43" />
              </div>

              {/* Opening Section */}
              <div className="mb-10" data-id="element-44">
                <p className="mb-4" data-id="element-45">
                  You've been diagnosed with lipedema. You tried compression
                  stockings. And they didn't work.
                </p>
                <p className="mb-4" data-id="element-46">You're not alone.</p>
                <p className="mb-4" data-id="element-47">
                  Most compression stockings fail women with lipedema. And
                  there's a scientific reason why.
                </p>
                <p className="mb-4" data-id="element-48">
                  "We see women come into our clinic every day," says Dr. Rachel
                  Chen, a leading drainage specialist. "They've had trouble with
                  compression stockings for months or even years. They've done
                  everything their doctor told them to do. They've worn the
                  stockings every day. And they're still dealing with swelling,
                  pain, and frustration."
                </p>
                <p className="mb-4" data-id="element-49">
                  "The problem," Dr. Chen explains, "isn't the women. It's that
                  compression stockings were never made for lipedema in the
                  first place."
                </p>
                <p className="mb-4 font-semibold" data-id="element-50">
                  And now, there's finally a better solution.
                </p>
              </div>

              {/* The Truth About Compression Stockings Section */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-51">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-52">
                  The Truth About Compression Stockings
                </h2>

                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-53">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vZgTaXaxfHgpWtLhRDNWGn/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_30_%CF%80.%CE%BC..png" alt="Image showing traditional medical-grade compression stockings next to a frustrated woman trying to put them on, illustrating how uncomfortable and medical they look" className="w-full h-auto" data-id="element-54" />
                </div>

                <p className="mb-4" data-id="element-55">
                  Let's be honest. Compression stockings are uncomfortable.
                </p>
                <p className="mb-4" data-id="element-56">
                  They're hard to put on. They dig into your skin. They leave
                  painful marks. They're hot. And if you have lipedema, they
                  often make you feel worse.
                </p>
                <p className="mb-4" data-id="element-57">
                  But you kept wearing them. Your doctor said they would help.
                  You read that compression was supposed to reduce swelling. You
                  thought the right brand might finally work.
                </p>
                <p className="mb-4 font-semibold" data-id="element-58">Sound familiar?</p>
                <p className="mb-4" data-id="element-59">
                  Here's what most doctors don't tell you. Regular compression
                  stockings were made for varicose veins. And for elderly
                  patients with general swelling. Not for the unique drainage
                  problems and fat patterns of lipedema.
                </p>
                <p className="mb-4" data-id="element-60">
                  This isn't a small detail. It's the main reason compression
                  stockings fail so many women with lipedema.
                </p>
                <p className="mb-4" data-id="element-61">
                  Women in lipedema support groups report the same pattern:
                </p>
                <p className="mb-4" data-id="element-62">
                  They bought compression stockings after diagnosis. Had trouble
                  putting them on. Wore them for weeks or months despite the
                  discomfort. Saw little improvement. Eventually stopped wearing
                  them because the struggle wasn't worth the benefit.
                </p>
                <p className="mb-4" data-id="element-63">
                  The cycle of hope and disappointment is exhausting.
                </p>
                <p className="mb-4" data-id="element-64">
                  But the problem isn't you. It's not your commitment. It's not
                  that you didn't try hard enough or didn't find the "right"
                  stockings.
                </p>
                <p className="mb-4 font-semibold" data-id="element-65">
                  The problem is that compression stockings have three fatal
                  design flaws when it comes to lipedema.
                </p>
              </div>

              {/* The Three Fatal Flaws Section */}
              <div className="mb-10" data-id="element-66">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-67">
                  The Three Fatal Flaws of Regular Compression for Lipedema
                </h2>

                <p className="mb-4" data-id="element-68">
                  Lipedema specialists have found three critical problems with
                  regular compression stockings.
                </p>

                <div className="bg-red-50 p-6 rounded-md mb-6" data-id="element-69">
                  <p className="font-semibold mb-2 text-lg" data-id="element-70">
                    Flaw #1: The Same Pressure Everywhere Problem
                  </p>
                  <p className="mb-4" data-id="element-71">
                    Regular compression stockings use the same level of pressure
                    from top to bottom. They squeeze your entire leg with equal
                    pressure. Every area gets treated the same.
                  </p>
                  <p className="mb-4" data-id="element-72">
                    But lipedema legs aren't the same everywhere.
                  </p>
                  <p className="mb-4" data-id="element-73">
                    You have areas where fat builds up more heavily. You have
                    tender spots where pressure causes pain. You have points
                    where fluid builds up most.
                  </p>
                  <p className="mb-4" data-id="element-74">
                    "It's like using a one-size-fits-all approach for a very
                    individual condition," Dr. Chen explains. "The areas that
                    need the most support aren't getting it. And the areas that
                    need gentle treatment are being squeezed too hard."
                  </p>
                </div>

                <div className="bg-red-50 p-6 rounded-md mb-6" data-id="element-75">
                  <p className="font-semibold mb-2 text-lg" data-id="element-76">
                    Flaw #2: The Drainage Mismatch
                  </p>
                  <p className="mb-4" data-id="element-77">
                    Here's the biggest issue. Your drainage system has specific
                    pathways. Fluid needs to move in one direction. Up and out
                    of your legs. Back toward your core. Following your body's
                    natural drainage routes.
                  </p>
                  <p className="mb-4" data-id="element-78">
                    Regular compression stockings don't follow these pathways.
                    They squeeze everywhere the same. This can trap fluid
                    instead of moving it.
                  </p>
                  <p className="mb-4" data-id="element-79">
                    Think of it like trying to drain a bathtub by pushing water
                    from the middle. Instead of letting it flow naturally to the
                    drain. You're working against your body's natural system.
                  </p>
                </div>

                <div className="bg-red-50 p-6 rounded-md mb-6" data-id="element-80">
                  <p className="font-semibold mb-2 text-lg" data-id="element-81">
                    Flaw #3: They Weren't Made for Lipedema
                  </p>
                  <p className="mb-4" data-id="element-82">
                    Regular medical compression stockings were developed decades
                    ago. They were made for varicose veins. For blood clots. And
                    for general leg swelling.
                  </p>
                  <p className="mb-4" data-id="element-83">
                    Lipedema is different. It involves damaged fat cells.
                    Ongoing inflammation. And poor drainage in a pattern that's
                    unique to this condition.
                  </p>
                  <p className="mb-4" data-id="element-84">
                    "You can't treat lipedema the same way you treat varicose
                    veins," says Dr. Chen. "The biology is completely different.
                    Women with lipedema need compression that's made for their
                    condition."
                  </p>
                </div>
              </div>

              {/* What Diagnosed Women Started Finding Section */}
              <div className="mb-10" data-id="element-85">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-86">
                  What Diagnosed Women Started Finding
                </h2>

                <p className="mb-4" data-id="element-87">
                  Women in lipedema support groups and online communities
                  started asking a different question.
                </p>
                <p className="mb-4 italic" data-id="element-88">
                  "Has anyone found compression that works for lipedema?"
                </p>
                <p className="mb-4" data-id="element-89">
                  The answers were hard to hear. Most women reported the same
                  experience with regular compression stockings:
                </p>

                <div className="bg-gray-50 p-4 rounded-md mb-6 space-y-2" data-id="element-90">
                  <p className="italic" data-id="element-91">
                    "I can barely get them on in the morning."
                  </p>
                  <p className="italic" data-id="element-92">"They hurt more than they help."</p>
                  <p className="italic" data-id="element-93">
                    "I saw maybe 10% improvement after wearing them for months."
                  </p>
                  <p className="italic" data-id="element-94">
                    "I gave up after a few weeks because I couldn't stand them
                    anymore."
                  </p>
                </div>

                <p className="mb-4" data-id="element-95">
                  But then, some women started sharing something different.
                </p>
                <p className="mb-4" data-id="element-96">
                  They'd found a new type of compression technology. Something
                  made for lipedema's unique drainage problems and fat patterns.
                  Something that addressed every flaw that makes regular
                  compression stockings fail.
                </p>
                <p className="mb-4" data-id="element-97">
                  The reports from these women were different:
                </p>

                <div className="bg-green-50 p-4 rounded-md mb-6 space-y-2" data-id="element-98">
                  <p className="italic" data-id="element-99">"I want to wear these."</p>
                  <p className="italic" data-id="element-100">
                    "My legs feel lighter for the first time in years."
                  </p>
                  <p className="italic" data-id="element-101">"The swelling reduction lasts."</p>
                  <p className="italic" data-id="element-102">
                    "They look like regular leggings, not medical devices."
                  </p>
                  <p className="italic" data-id="element-103">
                    "I can wear compression all day without pain."
                  </p>
                </div>

                <p className="mb-4" data-id="element-104">
                  Word spread quickly through lipedema communities. Women who'd
                  given up on compression entirely started trying this
                  alternative. And the results kept coming back positive.
                </p>
              </div>

              {/* The Breakthrough Section */}
              <div className="mb-10" data-id="element-105">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-106">
                  The Compression Breakthrough Lipedema Specialists Are
                  Recommending
                </h2>

                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-107">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qXr4YxNDa3ZLDxwoFvkcy4/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_34_%CF%80.%CE%BC..png" alt="Image of Elivara compression leggings showing the stylish design with FlowMapping™ technology zones highlighted with glowing orange lines" className="w-full h-auto" data-id="element-108" />
                </div>

                <p className="mb-4" data-id="element-109">
                  A company called Elivara has developed the first truly
                  lipedema-specific compression. Specialists are calling it a
                  breakthrough. And it's nothing like regular compression
                  stockings.
                </p>
                <p className="mb-4" data-id="element-110">
                  It's called FlowMapping™ Compression Technology. And it
                  addresses every flaw that makes regular compression fail for
                  lipedema.
                </p>
                <p className="mb-4 font-semibold" data-id="element-111">Here's how it works:</p>
                <p className="mb-4" data-id="element-112">
                  Elivara uses different pressure areas that are mapped to your
                  body's drainage system. The pressure is strongest at your
                  ankles (where fluid tends to build up most). And it gets
                  lighter as it moves up your leg.
                </p>
                <p className="mb-4" data-id="element-113">
                  This creates a gentle pressure slope. It naturally encourages
                  trapped fluid to move upward and drain properly. Following
                  your body's natural pathways instead of fighting against them.
                </p>
                <p className="mb-4" data-id="element-114">
                  But here's what sets Elivara apart. They didn't adapt existing
                  compression technology for lipedema. They built it from the
                  ground up for women with this condition.
                </p>
                <p className="mb-4" data-id="element-115">That means:</p>

                <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-116">
                  <li data-id="element-117">
                    Pressure areas built around lipedema's unique fat patterns
                  </li>
                  <li data-id="element-118">
                    Gentle compression in tender areas where regular stockings
                    cause pain
                  </li>
                  <li data-id="element-119">
                    Extra support in areas where lipedema fat builds up most
                    heavily
                  </li>
                  <li data-id="element-120">
                    Fabric that's breathable, comfortable, and made for all-day
                    wear
                  </li>
                  <li data-id="element-121">
                    A design that looks like regular leggings—not medical
                    devices
                  </li>
                </ul>

                <p className="mb-4" data-id="element-122">
                  "This is what compression for lipedema should have been all
                  along," says Dr. Chen, who now recommends Elivara to her
                  patients. "It's medical-level support that follows the science
                  of how drainage works. Made for the way lipedema affects the
                  body."
                </p>
              </div>

              {/* Visual Explanation of FlowMapping™ Technology */}
              <div className="mb-10" data-id="element-123">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-124">
                  See the FlowMapping™ Difference
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden bg-blue-50 p-4" data-id="element-125">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ge5gzuHf48wNS9HaJaGCz/gempages_541671622348637232-7a3a123c-f1c8-4b25-b1a4-f051e570e74b.webp" alt="Animation showing the difference between painful lipedema fluid buildup (left, red areas) and the FlowMapping™ technology directing fluid flow (right, green chevrons)" className="w-full h-auto mx-auto" data-id="element-126" />
                  <div className="flex justify-between mt-4 text-sm md:text-base" data-id="element-127">
                    <div className="text-center w-1/2 border-r border-blue-200 pr-2" data-id="element-128">
                      <p className="font-bold text-red-500 mb-1" data-id="element-129">
                        WITHOUT SUPPORT
                      </p>
                      <p className="text-gray-700" data-id="element-130">
                        Painful fluid buildup and inflammation
                      </p>
                    </div>
                    <div className="text-center w-1/2 pl-2" data-id="element-131">
                      <p className="font-bold text-green-500 mb-1" data-id="element-132">
                        WITH FLOWMAPPING™
                      </p>
                      <p className="text-gray-700" data-id="element-133">
                        Guided fluid drainage along natural pathways
                      </p>
                    </div>
                  </div>
                </div>
                <p className="mb-4" data-id="element-134">
                  This visual perfectly captures what makes FlowMapping™
                  technology so revolutionary. On the left, you can see what
                  happens in lipedema-affected legs: fluid builds up (shown in
                  red), creating painful inflammation and swelling that doesn't
                  respond to diet or exercise.
                </p>
                <p className="mb-4" data-id="element-135">
                  On the right, you see how Elivara's patented FlowMapping™
                  technology works. The strategically placed compression zones
                  (shown as green chevrons) create directional pressure that
                  guides trapped fluid along your natural lymphatic pathways.
                  This helps your body drain the fluid properly, reducing
                  swelling, pain, and that heavy feeling that comes with
                  lipedema.
                </p>
              </div>

              {/* What Women Are Experiencing Section */}
              <div className="mb-10" data-id="element-136">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-137">
                  What Women Are Experiencing
                </h2>

                <p className="mb-6" data-id="element-138">
                  The results women are reporting with Elivara are different
                  from their experiences with regular compression stockings.
                </p>

                <div className="space-y-6 mb-6" data-id="element-139">
                  <TestimonialCard quote="I wore compression stockings for 8 months and saw almost no improvement. I've been wearing Elivara for 3 weeks and the difference is incredible." author="Patricia G." age="47" location="Brooklyn, NY" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/eb9DbMXxnEv4xRdj6M31AN/Beth_-_living_with_lipedema.webp" data-id="element-140" />

                  <TestimonialCard quote="I was so frustrated with compression stockings. They were impossible to put on, they hurt, and they barely helped. I kept wearing them because my doctor said I should. But I dreaded it every single day. Elivara is completely different. They feel like regular leggings. They don't hurt. And my legs feel lighter by the end of the day. I can't believe I had trouble with those stockings for so long when this is what compression should have been." author="Diana L." age="52" location="Manhattan, NY" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/3y7To7DiABw2UivqWYkvYv/images_%2842%29.jpg" data-id="element-141" />

                  <TestimonialCard quote="For the first time since my diagnosis, I can wear compression without feeling like I'm suffocating my legs." author="Nicole R." age="39" location="Queens, NY" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/1ZzQbxP1337U3TnJrDfMSW/istockphoto-1290775513-612x612.jpg" data-id="element-142" />

                  <TestimonialCard quote="Regular compression stockings made me feel trapped. The pressure was so uncomfortable. I could never wear them for more than a few hours before I had to take them off. Elivara's different pressure areas feel completely different. Supportive without being restrictive. And the fact that they look like normal leggings means I can wear them out of the house. I wear them every day now." author="Michelle K." age="44" location="Long Island, NY" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/jA5TbK1HAopveddK7FXfLL/mockup-pretty-curvy-latin-woman-600nw-2460705183.webp" data-id="element-143" />

                  <TestimonialCard quote="My swelling has decreased more in one month with Elivara than in six months with compression stockings." author="Rebecca L." age="44" location="Nashville, TN" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/8hW674k71ojpsCMkVCgv6R/Screenshot_2025-09-30_at_00.02.40.png" data-id="element-144" />

                  <TestimonialCard quote="I thought I was doing something wrong with compression stockings because they weren't helping. My doctor kept telling me to wear them. But my legs were still swollen and painful every single day. When I switched to Elivara, I finally understood what properly made compression feels like. The swelling has gone down. The pain is less. And I want to wear them because they're comfortable." author="Amanda K." age="38" location="Austin, TX" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/hq1HCFwLGMXQeBfL6EFNpY/istockphoto-1180524344-612x612.jpg" data-id="element-145" />

                  <TestimonialCard quote="I can travel again without my legs ballooning up. Before Elivara, any long car ride or flight was torture. My legs would swell so badly I could barely walk afterward. Regular compression stockings didn't help much. And they were so uncomfortable I couldn't stand wearing them for long trips. Now I wear my Elivara leggings whenever I travel. And it's made such a difference. My legs stay comfortable even on long flights." author="Linda M." age="51" location="Chicago, IL" imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/nJ43KvrRnAa3kWNkkTfCWz/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_12_12_37_%CF%80.%CE%BC..png" data-id="element-146" />
                </div>
              </div>

              {/* Why Elivara Works Section */}
              <div className="mb-10" data-id="element-147">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-148">
                  Why Elivara Works When Compression Stockings Don't
                </h2>

                <p className="mb-4" data-id="element-149">
                  Let's compare regular compression stockings to Elivara's
                  FlowMapping™ approach side by side:
                </p>

                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-150">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sngffNnPS6asvvdqPakuVW/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_52_%CF%80.%CE%BC..png" alt="Illustration comparing Traditional Compression with uniform pressure versus FlowMapping™ Technology with directional support following the lymphatic system pathways" className="w-full h-auto" data-id="element-151" />
                </div>

                <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-152">
                  <div className="bg-red-50 p-6 rounded-lg" data-id="element-153">
                    <h3 className="font-bold text-lg mb-4 text-red-700" data-id="element-154">
                      Regular Compression Stockings:
                    </h3>
                    <ul className="space-y-2 text-sm" data-id="element-155">
                      <li data-id="element-156">• Same pressure throughout</li>
                      <li data-id="element-157">• Generic medical device design</li>
                      <li data-id="element-158">• One-size-fits-all approach</li>
                      <li data-id="element-159">• Hard to put on and uncomfortable</li>
                      <li data-id="element-160">• Don't follow drainage pathways</li>
                      <li data-id="element-161">• Look obviously medical</li>
                      <li data-id="element-162">• Made for varicose veins, not lipedema</li>
                    </ul>
                  </div>

                  <div className="bg-green-50 p-6 rounded-lg" data-id="element-163">
                    <h3 className="font-bold text-lg mb-4 text-green-700" data-id="element-164">
                      Elivara FlowMapping™ Compression:
                    </h3>
                    <ul className="space-y-2 text-sm" data-id="element-165">
                      <li data-id="element-166">
                        • Different pressure areas (strongest at ankle, lighter
                        upward)
                      </li>
                      <li data-id="element-167">• Lipedema-specific design</li>
                      <li data-id="element-168">• Tailored to lipedema's unique fat patterns</li>
                      <li data-id="element-169">• Easy to wear, comfortable all day</li>
                      <li data-id="element-170">• Maps directly to drainage pathways</li>
                      <li data-id="element-171">• Looks like stylish athleisure leggings</li>
                      <li data-id="element-172">• Built for women with lipedema</li>
                    </ul>
                  </div>
                </div>

                <p className="mb-4" data-id="element-173">The difference isn't subtle. It's basic.</p>
                <p className="mb-4" data-id="element-174">
                  "Women tell me all the time that they can't believe how
                  different Elivara feels compared to regular compression," says
                  Dr. Chen. "That's because it's made completely differently.
                  It's not a marketing difference. It's a real technology
                  difference in how the compression is made and applied."
                </p>
              </div>

              {/* This Is Your Chance Section */}
              <div className="mb-10 bg-gray-100 p-6 rounded-lg" data-id="element-175">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-176">
                  This Is Your Chance to Try Compression That Works
                </h2>

                <div className="mb-6 bg-white rounded-lg overflow-hidden" data-id="element-177">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/23Hx8bzAVQ7dcDK8zTNUdC/Trusted_by_Women_Across_the_USA.png" alt="Elivara Lipedema Leggings with premium packaging, 30-day money back guarantee, and free shipping" className="w-full h-auto" data-id="element-178" />
                </div>

                <p className="mb-4" data-id="element-179">
                  Here's something important to know. Elivara uses specialized
                  FlowMapping™ technology. It's made for lipedema. Because of
                  this, they can only produce limited quantities at a time.
                </p>
                <p className="mb-4" data-id="element-180">
                  Right now, they're offering first-time customers an exclusive
                  opportunity to save 40% off their order.
                </p>
                <p className="mb-4" data-id="element-181">
                  This isn't a permanent discount. It's made to help women
                  who've been frustrated with regular compression. To finally
                  access a solution that works for their condition. Without the
                  premium price tag that usually comes with specialized medical
                  items.
                </p>
                <p className="mb-4 font-semibold" data-id="element-182">
                  But here's the reality. Elivara sells out regularly.
                </p>
                <p className="mb-4" data-id="element-183">
                  When women discover compression that feels comfortable and
                  provides real relief, word spreads fast. Through support
                  groups and online communities. Popular sizes often disappear
                  within days. And then you have to wait weeks for the next
                  production run.
                </p>
                <p className="mb-4" data-id="element-184">
                  If you've been having trouble with compression stockings that
                  don't work, this is your opportunity. To try something
                  completely different.
                </p>
              </div>

              {/* You Weren't Doing Compression Wrong Section */}
              <div className="mb-10" data-id="element-185">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-186">
                  You Weren't Doing Compression Wrong—You Just Didn't Have the
                  Right Compression
                </h2>

                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-187">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fcFTP9s5La88PDr9GNhj1H/ChatGPT_Image_30_%CE%A3%CE%B5%CF%80_2025%2C_11_41_56_%CF%80.%CE%BC..png" alt="Woman confidently walking on the beach wearing a dress with compression leggings, enjoying freedom and comfort after using Elivara to manage her lipedema" className="w-full h-auto" data-id="element-188" />
                </div>

                <p className="mb-4" data-id="element-189">
                  If you've spent months wearing compression stockings, I want
                  you to hear this clearly. If they weren't helping, it's not
                  your fault.
                </p>
                <p className="mb-4 font-semibold" data-id="element-190">
                  You were using the wrong type of compression for your
                  condition.
                </p>
                <p className="mb-4" data-id="element-191">
                  Compression stockings were made for varicose veins and general
                  swelling in elderly patients. The fact that they didn't work
                  well for your lipedema isn't a failure on your part. It's a
                  design flaw in the product.
                </p>
                <p className="mb-4" data-id="element-192">
                  You don't need to try harder with compression stockings. You
                  don't need to find a "better" brand of the same flawed
                  approach. You don't need to force yourself to wear something
                  that causes pain and provides little benefit.
                </p>
                <p className="mb-4 font-semibold" data-id="element-193">
                  You need compression that was built for lipedema.
                </p>
                <p className="mb-4" data-id="element-194">
                  Compression that follows your body's natural drainage
                  pathways. Compression that accounts for lipedema's unique fat
                  distribution and tender areas. Compression that looks and
                  feels like regular leggings but delivers medical-level relief.
                </p>
                <p className="mb-4" data-id="element-195">Now, for the first time, that exists.</p>
                <p className="mb-4" data-id="element-196">
                  Imagine putting on a pair of leggings in the morning that make
                  your legs feel better throughout the day. Instead of worse.
                </p>
                <p className="mb-4" data-id="element-197">
                  Imagine that heavy, swollen feeling starting to lift. Imagine
                  less pain. Less tenderness. Less constant awareness of your
                  legs as a problem you have to manage.
                </p>
                <p className="mb-4" data-id="element-198">
                  Imagine wearing a dress in the summer without a second
                  thought. Going to the beach. Traveling without fear of your
                  legs swelling. Exercising without the extra discomfort that
                  lipedema brings.
                </p>
                <p className="mb-4 font-semibold" data-id="element-199">
                  Imagine living normally. Without constantly thinking about
                  your legs.
                </p>
                <p className="mb-4" data-id="element-200">
                  That's what Elivara gave me. And that's what it can give you.
                </p>
                <p className="mb-4" data-id="element-201">
                  You're not alone. You're not broken. And you're not imagining
                  this condition.
                </p>
                <p className="mb-4" data-id="element-202">
                  Lipedema is real. It's valid. And now, there's finally a
                  solution that works.
                </p>
                <p className="mb-6 font-semibold" data-id="element-203">
                  Don't let another doctor tell you it's "just weight." Discover
                  Elivara today.
                </p>
                <p className="mb-4" data-id="element-204">
                  Don't wait until they're sold out again. Don't spend another
                  season hiding. Don't let another year go by feeling frustrated
                  and stuck.
                </p>
                <p className="mb-4" data-id="element-205">
                  Your legs deserve relief. And you deserve to feel confident
                  and comfortable in your own body again.
                </p>
              </div>
            </div>
          </main>

          {/* Right-side CTA - Always visible on desktop */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-206">
            <div className="sticky top-6" data-id="element-207">
              <StickyCTA showNewImage={true} data-id="element-208" />
            </div>
          </aside>
        </div>
      </div>

      {/* Sticky CTA - Always visible at the bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50" data-id="element-209">
        <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block" data-id="element-210">
          GET 40% OFF ELIVARA LEGGINGS NOW!
        </a>
      </div>

      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-211">
        <div className="container mx-auto px-4 py-6" data-id="element-212">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-4" data-id="element-213">
            <div className="flex items-center" data-id="element-214">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-215" />
              <p className="font-bold text-lg" data-id="element-216">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-lg px-4" data-id="element-217">
              Get Elivara Compression Leggings at 40% OFF + FREE Shipping for a
              Limited Time!
            </p>
            <a href="https://tryelivara.com/pages/elivara-landing-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg text-base whitespace-nowrap inline-block" data-id="element-218">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <footer className="w-full bg-gray-100" data-id="element-219">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-220">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-221">
            <p className="mb-2" data-id="element-222">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Individual results may vary.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-223">
              <span data-id="element-224">About Us</span>
              <span data-id="element-225">|</span>
              <span data-id="element-226">Terms of Use</span>
              <span data-id="element-227">|</span>
              <span data-id="element-228">Privacy Policy</span>
            </div>
            <p className="mb-2" data-id="element-229">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p data-id="element-230">©2025 Women's Health Insights. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};